module.exports = __webpack_public_path__ + "static/9-03b87a38f34adde4188cb864c36111c7.jpg";